export interface IFiscalSetupProvider {
  id: number;
  fiscalSetupId: number;
  onboardingType: string;
  onboardingTypeNameTranslated: string;
  onboardingTypeDescriptionTranslated: string;
}
